import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="campaigns"
export default class extends Controller {
  static targets = ["nextButton"]

  connect() {
  }

  clicked(event) {
    this.nextButtonTarget.classList.remove("disabled")
    this.nextButtonTarget.innerHTML = this.nextButtonTarget.dataset.nextText
  }
}
